import { Badge } from './badge'
import { employeeTypeLabel } from '@/shared/lib/employeeType'

type RoleBadgeProps = { employeeType?: string; className?: string }

export function RoleBadge({ employeeType, className }: RoleBadgeProps) {
  if (!employeeType || employeeType === 'System') return null
  const tone = employeeType === 'Supervisor' ? 'info' : 'neutral'
  return <Badge tone={tone} className={className}>{employeeTypeLabel(employeeType)}</Badge>
}
